export default "__VITE_ASSET__CYRT0nRp__"